<!--批量  -->
<template>
	<div class="dialogBox">
		<el-dialog v-if="dialogVisible" title="批量调整路线员" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="680px" :before-close="cancle">
			<div class="ml15 mt20">
				<el-form  :inline="true" size="small"  :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px">
					<el-form-item label="主路线员" prop="mainUserCode">
						<el-input v-model="ruleForm.mainUserCode" class="w190" maxlength="16" readonly>
							<i slot="suffix"  @click="handleRouteUser(1)" class="el-input__icon el-icon-search"></i>
						</el-input>
					</el-form-item>
					<el-form-item label="主路线员名">
						<el-input v-model="ruleForm.mainUserName" class="w190" maxlength="16" readonly></el-input>
					</el-form-item>
					<el-form-item label="副路线员">
						<el-input v-model="ruleForm.secUserCode" class="w190" maxlength="16" readonly>
							<i slot="suffix"  @click="handleRouteUser(2)" class="el-input__icon el-icon-search"></i>
							<i slot="suffix" v-if="ruleForm.secUserCode" @click="handleClear" class="el-input__icon el-icon-circle-close"></i>
						</el-input>
					</el-form-item>
					<el-form-item label="副路线员名">
						<el-input v-model="ruleForm.secUserName" class="w190" maxlength="16" readonly></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer mt10">
				<el-button  size="small" @click="cancle()">取 消</el-button>
				<el-button  size="small" type="primary" @click="setBatchUpdate()">确 定</el-button>
			</span>
		</el-dialog>
		<addRouteUser ref="addRouteUser" @selectUserRows="selectUserRows" @flag="flag" ></addRouteUser>
	</div>
</template>

<script>
import addRouteUser from './add-route-user.vue'
	export default {
		components:{
			addRouteUser
		},
		props: {
			selectAttribute: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				dialogVisible: false,
				ruleForm: {
					groupId:"",
					mainUserCode:"",
					secUserCode:"",
					mainUserName:"",
					secUserName:""
				},
				rules:{
					mainUserCode: [{
						required: true,
						message: '请选择主路线员',
						trigger: 'change'
					}, ],
				},
				rows: [],
				selectUserId:{
					mainUserId:"",
					secUserId:"",
				},
				flagRow:[],
			}
		},
		created() {

		},
		methods: {
			init(rows) {
				this.dialogVisible = true
				this.$nextTick(() => {
					console.log(rows)
					this.ruleForm.groupId = window.sessionStorage.getItem("groupId")
					this.rows = rows
					this.selectUserId={
						mainUserId:"",
						secUserId:"",
					}
					this.ruleForm = {
						mainUserCode: "",
						secUserCode: "",
						mainUserName: "",
						secUserName: "",
					}
				
				})
			},
		//添加线路成员
			handleRouteUser(val) {
				this.$refs.addRouteUser.init(val, this.selectUserId,this.ruleForm.groupId)
			},
			// 添加线路员
			selectUserRows(val) {
				console.log(val)
				this.flagRow = val
			},
			//  添加线路员类型
			flag(val) {
				
				if (val == 1) {
					this.ruleForm.mainUserCode = this.flagRow[0].datas[1]
					this.ruleForm.mainUserName = this.flagRow[0].datas[0]
					this.selectUserId.mainUserId = this.flagRow[0].dataKey
					
				} else {
					this.ruleForm.secUserCode = this.flagRow[0].datas[1]
					this.ruleForm.secUserName = this.flagRow[0].datas[0]
					this.selectUserId.secUserId = this.flagRow[0].dataKey
				}

			},
			// 清除副路线员
			handleClear() {
				this.ruleForm.secUserCode = '';
				this.ruleForm.secUserName = ''

			},
			// 批量修改
			setBatchUpdate() {
				let that = this;
				that.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						if (this.ruleForm.mainUserCode == this.ruleForm.secUserCode) {
							this.$message.error('主路线员和副路线员不能一致!');
							return
						}
						let orderIds = []
						that.rows.forEach(item => {
							orderIds.push(item.dataKey)
						});
						that.$request.post(
								"batchUpdate",
								true, {
									routeIds: orderIds,
									mainUserCode: that.ruleForm.mainUserCode,
									secUserCode: that.ruleForm.secUserCode,
								}
							)
							.then((res) => {
								if (res.code==0) {
									that.dialogVisible = false
									that.$message.success("批量修改成功！");
									that.$refs['ruleForm'].resetFields();
									that.$emit("getList")
								}
							})
							} else {
								return false;
							}
						})
			},
			
			// 取消
			cancle() {
				this.dialogVisible = false;
				this.$refs['ruleForm'].resetFields();
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 0px 10px;
		}
	}

</style>
